import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { faCircleArrowUp } from '../../../icons';

@Component({
    selector: 'app-scroll-top',
    templateUrl: './scroll-top.component.html',
    styleUrls: ['./scroll-top.component.scss'],
    standalone: false
})
export class ScrollTopComponent implements OnInit {
  @Output() onScroll: EventEmitter<number> = new EventEmitter();
  @Output() onScrollFinished: EventEmitter<boolean> = new EventEmitter();

  faCircleArrowUp = faCircleArrowUp;

	scrollY: number = 0;
  prevScrollY: number = 0;

	scrolling: boolean = false;
	interval = null;


  constructor() { }

  ngOnInit(): void {
    let aux = 0;
  	if(this.interval == null) {
  		this.interval = setInterval(() => {
  			this.scrollY = window.scrollY;
        if(this.scrollY == this.prevScrollY) {
          aux++;
          if(aux == 2) {
            this.doneScrolling();
          }
        } else {
          aux = 0;
          this.scrolling = true;
          this.prevScrollY = this.scrollY;
          this.onScroll.emit(this.scrollY);
        }
  		}, 150);
  	}
  }

  ngOnDestroy() {
  	if(this.interval)
  		clearInterval(this.interval);
  }

  scroll() {
  	this.scrolling = true;
  	window.scrollTo({top: 0, behavior: 'smooth'});
  }

  doneScrolling() {
    this.scrolling = false;
    this.onScrollFinished.emit(true);
  }

}
